// extracted by mini-css-extract-plugin
export default {"sepContainer":"Separator_sepContainer_15ZAW","sep":"Separator_sep_1bwGC","sepLabel":"Separator_sepLabel_3FkSU"};